if (typeof ShippingNotice !== 'function') {
  class ShippingNotice extends HTMLElement {

    constructor() {
      super();
      this.init();
      this.setupObserver();
    }

    setupObserver() {
      const observer = new MutationObserver(() => {
        const textElement = this.querySelector('[data-js-free-shipping-text]');
        if (textElement && textElement.innerHTML === '') {
          this.init();
        }
      });

      observer.observe(this, {
        childList: true,
        subtree: true,
      });
    }

    init() {
      const freeShippingThreshold = Math.round(
        Number(this.getAttribute('data-free-shipping')) *
        (Shopify.currency.rate ? Number(Shopify.currency.rate) : 1)
      );
      const cartTotal = Number(this.getAttribute('data-cart-total'));
      const hasSubscription = this.getAttribute('data-has-subscription') === 'true';
      const freeShippingRemaining = cartTotal - freeShippingThreshold;

      let cartSliderWidth = 0;
      if (hasSubscription || freeShippingRemaining >= 0) {
        this.querySelector('[data-js-free-shipping-text]').innerHTML =
          this.getAttribute('data-eligible-text');  
        cartSliderWidth = 100;
      } else {
        const remainingFormatted = this._formatMoney(
          Math.abs(freeShippingRemaining),
          this.getAttribute('data-money-format')
        );
        this.querySelector('[data-js-free-shipping-text]').innerHTML = this.getAttribute(
          'data-remaining-text'
        ).replace('{{ remaining_amount }}', remainingFormatted);
        cartSliderWidth = 100 - (Math.abs(freeShippingRemaining) * 100) / freeShippingThreshold;
      }

        const shippingSlider = this.querySelector('[data-js-free-shipping-slider]');
        if (shippingSlider) {
          shippingSlider.style.width = `${cartSliderWidth}%`;
          shippingSlider.parentElement?.classList.toggle('cart-notice__slider--full', cartSliderWidth >= 100);
        }
      }

      _formatMoney(cents, format) {
        if (typeof cents === 'string') {
          cents = cents.replace('.', '');
        }

        let value = '';
        const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
        const formatString = format || '{{ amount }}';

        function formatWithDelimiters(number, precision, thousands, decimal) {
          thousands = thousands || ',';
          decimal = decimal || '.';

          if (isNaN(number) || number === null) {
            return 0;
          }

          number = (number / 100.0).toFixed(precision);

          const parts = number.split('.');
          const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
          const centsAmount = parts[1] ? decimal + parts[1] : '';

          return dollarsAmount + centsAmount;
        }

        const match = formatString.match(placeholderRegex);
        if (match) {
          switch (match[1]) {
            case 'amount':
              value = formatWithDelimiters(cents, 2);
              break;
            case 'amount_no_decimals':
              value = formatWithDelimiters(cents, 0);
              break;
            case 'amount_with_comma_separator':
              value = formatWithDelimiters(cents, 2, '.', ',');
              break;
            case 'amount_no_decimals_with_comma_separator':
              value = formatWithDelimiters(cents, 0, '.', ',');
              break;
            case 'amount_no_decimals_with_space_separator':
              value = formatWithDelimiters(cents, 0, ' ');
              break;
            case 'amount_with_apostrophe_separator':
              value = formatWithDelimiters(cents, 2, "'");
              break;
            default:
              value = formatWithDelimiters(cents, 2);
          }
        }

        return formatString.replace(placeholderRegex, value);
      }
    }

    if(typeof customElements.get('shipping-notice') == 'undefined') {
    customElements.define('shipping-notice', ShippingNotice);
  }
}